import YelpIcon from '../../../images/Yelp.png';

const Yelp = () => (
  <div className="order-res-links-icon">
    <img src={YelpIcon} alt="Yelp" />
  </div>
);

export default Yelp;
